import React from 'react';
import { Button, Form, Segment } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import 'react-widgets/dist/css/react-widgets.css';
import 'react-datepicker/dist/react-datepicker.css';


export default class CourseFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            courseImplementations: [],
            gradedActivities: [],
            courseImplementationName: '',
            gradedActivityName: '',
            endDate: null,
            startDate: null,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.onFilterData = this.onFilterData.bind(this);
        this.getDataForFilter = this.getDataForFilter.bind(this);
    }

    componentDidMount() {
        this.getDataForFilter();
    }


    onFilterData() {
        this.props.onFilterData(
            this.state.courseImplementationName,
            this.state.gradedActivityName,
            this.state.startDate,
            this.state.endDate
        );
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    getDataForFilter() {
        const { data } = this.props;

        // courseImplementations
        let courseImplementationsResult = data.sort().reduce((accumulator, current) => {
            const dataLength = accumulator.length;
            if (dataLength === 0 || accumulator[dataLength - 1] !== current.courseImplementationName) {
                accumulator.push(current.courseImplementationName);
            }
            return accumulator;
        }, []);

        const courseImplementations = courseImplementationsResult.map(el => ({
            key: el,
            value: el,
            text: el
        }));

        // gradedActivities
        let gradedActivitiesResult = data.sort().reduce((accumulator, current) => {
            const dataLength = accumulator.length;
            if (dataLength === 0 || accumulator[dataLength - 1] !== current.gradedActivityName) {
                accumulator.push(current.gradedActivityName);
            }
            return accumulator;
        }, []);

        const gradedActivities = gradedActivitiesResult.map(el => ({
            key: el,
            value: el,
            text: el
        }));


        this.setState({ courseImplementations, gradedActivities });
    }


    render() {
        return (
            <Segment clearing>
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>                                                                                                                                                                                                                                                                                                                                                                                                                                                                     {<FormattedMessage id="professorInputGrades.course" />}</label>
                            <Form.Dropdown clearable
                                placeholder={<FormattedMessage id="professorInputGrades.selectCourse" />}
                                value={this.state.courseImplementationName}
                                onChange={this.handleInputChange}
                                name="courseImplementationName"
                                options={this.state.courseImplementations}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 {<FormattedMessage id="professorInputGrades.examType" />}</label>
                            <Form.Dropdown clearable
                                placeholder={<FormattedMessage id="professorInputGrades.selectExamTerms" />}
                                value={this.state.gradedActivityName}
                                onChange={this.handleInputChange}
                                name="gradedActivityName"
                                options={this.state.gradedActivities}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                    </Form.Group>
                    {/** <Form.Group widths="equal">
                        <Form.Field>
                            <label>{<FormattedMessage id="professorInputGrades.endDate" />}</label>
                            <DateTimePicker
                                format="DD.MM.YYYY."
                                defaultValue={null}
                                time={false}
                                onChange={this.handleDateChange.bind(null, 'endDate')}
                                value={this.state.endDate}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>{<FormattedMessage id="professorInputGrades.startDate" />}</label>
                            <DateTimePicker
                                format="DD.MM.YYYY."
                                defaultValue={new Date()}
                                time={false}
                                onChange={this.handleDateChange.bind(null, 'startDate')}
                                value={this.state.startDate}
                            />
                        </Form.Field>
                    </Form.Group>* */}
                    <Button color="blue" onClick={this.onFilterData}>{<FormattedMessage id="professorInputGrades.getFilter" />}
                    </Button>

                    <Button basic="true" color="blue" onClick={this.props.filtersOff}>{<FormattedMessage id="common.cancelO" />}
                    </Button>
                </Form>
            </Segment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorHistoryGrades/CourseFilter.js